import { getAccessToken } from "../contexts/AuthContext";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function authenticatedBackendFetch(
  endpoint: string,
  instance: IPublicClientApplication,
  account: AccountInfo,
  options: RequestInit = {},
) {
  const token = await getAccessToken(instance, account);

  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  return fetch(`${backendUrl}/${endpoint}`, {
    ...options,
    headers,
  });
}
